import { TilesCollectionComponent } from './TilesCollection';
export default TilesCollectionComponent;
